<div class="container">
  <div class="header">
    <mat-form-field appearance="fill">
      <mat-label>Month and Year</mat-label>
      <input
        matInput
        [matDatepicker]="dp"
        [formControl]="date"
        [min]="minDate"
        readonly />
      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
      <mat-datepicker
        #dp
        startView="multi-year"
        (yearSelected)="chosenYearHandler($event)"
        (monthSelected)="chosenMonthHandler($event, dp)"
        panelClass="example-month-picker">
      </mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill" class="filter-field">
      <mat-label>Activity Type</mat-label>
      <mat-select [formControl]="activityTypeFilter" multiple>
        <mat-option
          *ngFor="let type of activityTypeOptions"
          [value]="type.value">
          {{ type.viewValue }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="table-container mat-elevation-z8">
    <div class="loading-shade" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>

    <table mat-table [dataSource]="dataSource" matSort>
      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.date | date : 'shortDate' }}
        </td>
      </ng-container>

      <!-- Board Type Column -->
      <ng-container matColumnDef="boardType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Board Type</th>
        <td mat-cell *matCellDef="let element">{{ element.boardType }}</td>
      </ng-container>

      <!-- Address Column -->
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
        <td mat-cell *matCellDef="let element">{{ element.address }}</td>
      </ng-container>

      <!-- Activity Type Column -->
      <ng-container matColumnDef="activityType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Activity Type</th>
        <td mat-cell *matCellDef="let element">
          {{ element.activityType | titlecase }}
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let element">
          {{ element.status | titlecase }}
        </td>
      </ng-container>

      <!-- Notes Column -->
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
        <td mat-cell *matCellDef="let element">{{ element.notes }}</td>
      </ng-container>

      <!-- Admin Notes Column -->
      <ng-container matColumnDef="adminNotes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Admin Notes</th>
        <td mat-cell *matCellDef="let element">{{ element.adminNotes }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td
          class="mat-cell"
          colspan="7"
          style="text-align: center; padding: 20px">
          <span *ngIf="!isLoading">No activity found for this month.</span>
        </td>
      </tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 25, 100]"
      aria-label="Select page of users"></mat-paginator>
  </div>
</div>
